export interface UserContextRoleIdDTO {
    userRoleContextId: number;
    contextCd?: string;
    roleCd?: string;
}
